import { Success } from '@/components/Media/Icon';
import { Body } from '@/components/Typography';
import { colors } from '@/styles/theme/constants';
import { Flex } from '@chakra-ui/react';
import { type FC } from 'react';
import type { ChecklistItemProps } from './types';

const ChecklistItem: FC<ChecklistItemProps> = ({ text, isError }) => {
  return (
    <Flex data-testid="listItem_passwordValidation" gap="8px">
      <Success width={18} height={18} fill={isError ? colors.shade04 : colors.green03} />
      <Body variant="Default12" color={isError ? 'shade04' : 'green03'}>{text}</Body>
    </Flex>
  );
}

export default ChecklistItem;
